import { useToasts } from '@geist-ui/react'
import { ToastAction } from '@geist-ui/react/dist/use-toasts/use-toast'
import { network } from '../metadata/2021-12-22/primitives/network'

interface TxParams {
  nw: network
  hash: string
  text: string
  onView?: () => void
}

type TxReturnType = (params: TxParams) => void

export const useTxToast = (): TxReturnType => {
  const [, setToast] = useToasts()

  const showTxToast = ({ nw, hash, text, onView }: TxParams): void => {
    const host =
      nw === network.ETH_MAINNET
        ? 'etherscan.io'
        : nw === network.ETH_RINKEBY
        ? 'rinkeby.etherscan.io'
        : nw === network.SOL_MAINNET || nw === network.SOL_DEVNET
        ? 'explorer.solana.com'
        : null
    const action: ToastAction = {
      name: 'View Tx',
      handler: () => {
        window.open(
          `https://${host}/tx/${hash}${nw === network.SOL_DEVNET ? '?cluster=devnet' : ''}`,
          '_blank'
        )
        onView && onView()
      },
    }
    setToast({
      text,
      type: 'success',
      actions: [action],
      delay: 5000,
    })
  }

  return showTxToast
}
